// Where a pest-trap visit photo lives in the scouting-photos bucket (Traps,
// mig 20261038600000). Shared by the offline queue's uploader and the Traps
// screens, so the key has one definition.

/** `traps/<trap>/<visit>-<photo>.<ext>`, to go under the tenant prefix
 *  (tenantPath adds it). Keyed on client-minted ids, so the offline replay
 *  overwrites its own object instead of orphaning a second copy. */
export function trapVisitPhotoKey(trapId: string, visitId: string, photoId: string, fileName: string | null): string {
  const ext = (fileName?.split('.').pop() ?? 'jpg').toLowerCase().replace(/[^a-z0-9]/g, '') || 'jpg'
  return `traps/${trapId}/${visitId}-${photoId}.${ext}`
}
